import React, { useState } from "react";
import Carousel from "nuka-carousel";
import { Theme, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
    topBannerHeight: number,
    bannerCount: number,
};

const ImageCarousel: React.FC<Props> = ({ children, topBannerHeight, bannerCount = 1 }) => {
    const theme: Theme = useTheme();
    const [currentSlide, setCurrentSlide] = useState(0);

    const style = {
        width: '100vw',
        height: topBannerHeight,
    };

    return (
        bannerCount > 1 ? (
            <Carousel
                renderCenterLeftControls={() => null}
                renderCenterRightControls={() => null}
                autoplay
                wrapAround
                style={style}
                beforeSlide={(_currentIndex, nextIndex) => setCurrentSlide(nextIndex)}
                afterSlide={(newIndex) => setCurrentSlide(newIndex)}
                defaultControlsConfig={{
                    pagingDotsStyle: {
                        fill: theme.colours.white,
                    }
                }}
            >
                {React.Children.map(children, (child, index) => {
                    if (React.isValidElement(child)) {
                        return React.cloneElement(child, {
                            showButton: index === currentSlide,
                        } as any);
                    }
                    return child;
                })}
            </Carousel>
        ) : (
            <div>{children}</div>
        )
    );
}

export default ImageCarousel;
